import { ALL_BLOGS, AUTHOR, CATEGORY, QUERY } from './actionTypes';

export const allBlogs = () => ({
    type: ALL_BLOGS
});

export const sameCategory = (category) => ({
    type: CATEGORY,
    payload: category
});

export const sameAuthor = (author) => ({
    type: AUTHOR,
    payload: author
});

export const searchQuery = (query) => ({
    type: QUERY,
    payload: query
});
